// Developer mode utility functions

export const handleElementSelected = (elementInfo, setTargetElements) => {
  const isPlayerElement = elementInfo.position.y > window.innerHeight / 2;
  const defaultName = isPlayerElement ? 'Player ' : 'Opponent ';
  
  // Try to identify the element type
  const contextInfo = [];
  if (elementInfo.className) contextInfo.push(elementInfo.className);
  if (elementInfo.selector) contextInfo.push(elementInfo.selector);
  
  const contextString = contextInfo.length > 0 ? ` (${contextInfo.join(', ')})` : '';
  const name = prompt(`Enter a name for this element (${isPlayerElement ? 'Player' : 'Opponent'} element)${contextString}:`, 
    `${defaultName}${elementInfo.className || 'Element'}`);
  
  if (name) {
    setTargetElements(prev => [...prev, {
      id: `editable-${prev.length}`,
      name,
      className: elementInfo.className,
      selector: elementInfo.selector,
      position: elementInfo.position,
      size: elementInfo.size,
      isPlayerElement
    }]);
  }
};

export const handleElementMoved = (elementIndex, newX, newY, setTargetElements) => {
  console.log(`Element ${elementIndex} moved to:`, newX, newY);
  setTargetElements(prev => prev.map((element, index) => 
    index === elementIndex 
      ? { ...element, position: { x: newX, y: newY } }
      : element
  ));
};

export const handleElementResized = (elementIndex, newWidth, newHeight, setTargetElements) => {
  console.log(`Element ${elementIndex} resized to:`, newWidth, newHeight);
  setTargetElements(prev => prev.map((element, index) => 
    index === elementIndex 
      ? { ...element, size: { width: newWidth, height: newHeight } }
      : element
  ));
};

export const handleSaveDesign = (designChanges, setSavedDesign) => {
  console.log('Saving design changes:', designChanges);
  setSavedDesign(designChanges);
  alert('Design saved! Changes have been applied to the UI.');
  // Save to localStorage for persistence
  localStorage.setItem('battleUI_design', JSON.stringify(designChanges));
};

// Developer mode WebSocket actions
export const devActions = {
  fillEnemyZone: (ws, gameId, zone, orderId) => {
    if (ws && ws.readyState === 1) {
      console.log(`🛠️ DEV: Filling enemy ${zone} with order ${orderId}`);
      ws.send(JSON.stringify({
        type: "play-turn",
        gameId,
        action: { 
          type: "devFillZone", 
          zone: zone,
          orderId: parseInt(orderId),
          targetPlayer: "opponent"
        },
      }));
    }
  },

  clearZone: (ws, gameId, zone, targetPlayer) => {
    if (ws && ws.readyState === 1) {
      console.log(`🛠️ DEV: Clear ${targetPlayer} ${zone}`);
      ws.send(JSON.stringify({
        type: "play-turn",
        gameId,
        action: { 
          type: "devClearZone", 
          zone: zone,
          targetPlayer: targetPlayer
        },
      }));
    }
  },

  clearHand: (ws, gameId) => {
    if (ws && ws.readyState === 1) {
      console.log('🛠️ DEV: Clear player hand');
      ws.send(JSON.stringify({
        type: "play-turn",
        gameId,
        action: { 
          type: "devClearHand"
        },
      }));
    }
  },

  setIntelligence: (ws, gameId, intelligence) => {
    if (ws && ws.readyState === 1) {
      console.log(`🛠️ DEV: Set intelligence to ${intelligence}`);
      ws.send(JSON.stringify({
        type: "play-turn",
        gameId,
        action: { 
          type: "devSetIntelligence", 
          intelligence: parseInt(intelligence)
        },
      }));
    }
  },

  setMaxIntelligence: (ws, gameId, maxIntelligence) => {
    if (ws && ws.readyState === 1) {
      console.log(`🛠️ DEV: Set max intelligence to ${maxIntelligence}`);
      ws.send(JSON.stringify({
        type: "play-turn",
        gameId,
        action: { 
          type: "devSetMaxIntelligence", 
          maxIntelligence: parseInt(maxIntelligence)
        },
      }));
    }
  },

  setHealth: (ws, gameId, health) => {
    if (ws && ws.readyState === 1) {
      console.log(`🛠️ DEV: Set health to ${health}`);
      ws.send(JSON.stringify({
        type: "play-turn",
        gameId,
        action: { 
          type: "devSetHealth", 
          health: parseInt(health)
        },
      }));
    }
  },

  spawnAndAttack: (ws, gameId, unitId, zone) => {
    if (ws && ws.readyState === 1) {
      console.log(`🛠️ DEV: Spawn unit ${unitId} in ${zone} and attack`);
      ws.send(JSON.stringify({
        type: "play-turn",
        gameId,
        action: { 
          type: "devSpawnAndAttack", 
          unitId: unitId,
          zone: zone
        },
      }));
    }
  },

  deployUnit: (ws, gameId, unitId) => {
    if (ws && ws.readyState === 1) {
      console.log(`🛠️ DEV: Add unit ${unitId} to hand`);
      ws.send(JSON.stringify({
        type: "play-turn",
        gameId,
        action: { 
          type: "devDeployUnit", 
          unitId: parseInt(unitId) || unitId
        },
      }));
    }
  }
};
